import styled from 'styled-components'
import { Grid as MuiGrid } from '@mui/material'
import { BREAKPOINT_LG, BREAKPOINT_MD2, BREAKPOINT_SM, CONTAINER_MAX_WIDTH } from '../../theme/ota'

interface FormCriteriaProps {
  centered?: boolean
}
interface ContainerGridProps {
  marginBottom?: string
}

export const ContainerCriteria = styled.div<FormCriteriaProps>`
  &&& {
    align-items: center !important;
    display: flex !important;
    justify-content: space-between !important;
    margin: ${({ centered }) => (centered ? '0 auto' : '0')} !important;
    @media (min-width: calc(${BREAKPOINT_SM})) {
      max-width: ${CONTAINER_MAX_WIDTH} !important;
    }
    width: 100% !important;

    & > form {
      display: flex !important;
      flex-grow: 1;
      justify-content: start !important;
      width: 100% !important;

      @media (max-width: calc(${BREAKPOINT_SM})) {
        flex-direction: column !important;
        flex-wrap: wrap !important;
        align-self: stretch !important;
        display: block !important;
        font-size: 16px !important;
      }
    }
  }
`

export const TitleInputs = styled.p`
  &&& {
    box-shadow: none !important;
    color: currentColor;
    display: flex !important;
    font-size: 16px !important;
    font-weight: bold !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    text-shadow: none !important;

    @media (min-width: calc(${BREAKPOINT_SM})) {
      font-size: 13px !important;
    }

    span {
      font-weight: lighter !important;
      margin-left: auto !important;
    }
  }
`

export const TitleRoom = styled.p`
  &&& {
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 19.12px;
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: 16px !important;
    }
  }
`

export const BoxRoom = styled.div``

export const BoxOccupancy = styled.div`
  &&& {
    div.guest-count {
      align-items: center !important;
      display: flex !important;
      justify-content: space-between !important;

      ${TitleInputs} {
        font-size: 14px !important;
        font-weight: 400 !important;
        margin-bottom: 0 !important;

        small {
          color: ${({ theme }) => theme?.colors?.gray5} !important;
          display: block !important;
          font-size: 11px !important;
        }
      }

      .content-count {
        margin-bottom: 15px;
      }
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      padding-top: 20px !important;
      border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;

      div.guest-count {
        ${TitleInputs} {
          font-size: 16px !important;
        }
      }
      div.border {
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;
        padding-bottom: 20px !important;
      }
    }
  }
`

export const BtnPosition = styled.div`
  &&& {
    display: flex !important;
    justify-content: space-between !important;
    margin-top: 14px !important;
    min-width: 85px !important;
    padding-bottom: 1px !important;
    width: 100% !important;
  }
`

export const DateBaseStyles = styled.div`
  &&& {
    & + div {
      position: relative !important;
      left: 420px !important;
    }
  }
`

export const BoxChildren = styled.div`
  &&& {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-top: 15px !important;
    gap: 10px !important;
    margin-bottom: 20px !important;
    padding-left: 0 !important;

    div {
      flex: 1 !important;
      min-width: 85px !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      margin-bottom: 30px !important;
    }
  }
`

export const HeaderClient = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`

export const Container = styled.div`
  width: 100% !important;
`

export const ContainerHotelCriteria = styled.div<{ verticalOrientation?: boolean }>`
  &&& {
    display: flex;
    justify-content: center;
    width: 100%;
    //min-width: 1071px; Causou problema no widget no hottravel (botão buscar ficou colado na div)
    max-width: ${CONTAINER_MAX_WIDTH};

    & > form {
      display: flex !important;
      flex-direction: column !important;
      gap: 30px !important;
      width: 100%;
      margin: auto !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      min-width: auto;
    }
  }
`

// ================================
export const ContainerGrid = styled.div<ContainerGridProps>`
  &&& {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    width: 100%;

    input {
      font-family: 'Manrope', sans-serif;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      flex-wrap: wrap;
    }

    @media (min-width: calc(${BREAKPOINT_SM})) and (max-width: calc(${BREAKPOINT_LG})) {
      .destination-field {
        flex: 1.2;
        min-width: 150px;
      }
      .toggle-person-field {
        display: flex;
        max-width: 200px;
        min-height: 42px;
      }
      .person-field {
        min-width: 200px;
        max-width: 220px;
      }
      .date-field {
        flex: 0.8;
        min-width: 240px;
      }
      .occupancy-field {
        flex: 0.8;
        min-width: 115px;
      }
      .client-field {
        flex: 0.8;
        min-width: 110px;
      }
      .promocode-field {
        flex: 1;
        min-width: 110px;
        max-width: 174px;
      }
      .loyalty-option-field {
        min-width: 200px;
        max-width: 220px;
        flex-basis: 200px;
      }
    }

    @media (min-width: calc(${BREAKPOINT_LG})) {
      .destination-field {
        min-width: 180px;
        flex: 1;
      }
      .toggle-person-field {
        display: flex;
        max-width: 235px;
        min-height: 42px;
      }
      .person-field {
        min-width: 250px;
        max-width: 275.5px;
      }
      .date-field {
        flex: 0.8;
        min-width: 250px;
      }
      .occupancy-field {
        flex: 0.7;
        min-width: 130px;
      }
      .client-field {
        flex: 0.7;
        min-width: 130px;
      }
      .promocode-field {
        flex: 0.6;
        min-width: 120px;
      }
      .loyalty-option-field {
        flex-basis: 250px;
        min-width: 250px;
        max-width: 250px;
      }
    }
  }
`

export const Grid = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 100%;
    &:focus,
    &:focus-visible {
      border: none;
      outline: none;
    }

    &.loyalty-option-field {
      & .MuiInputBase-root {
        margin: 0;
        padding: 0 10px;

        & .MuiInputBase-input {
          margin: 0;
          padding: 0;
          height: 42px;

          @media (max-width: calc(${BREAKPOINT_SM})) {
            height: 52px;
          }
        }
      }
    }

    &.toggle-person-field {
      justify-content: center;
    }
  }
`

export const InputToggle = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 218px;

    label {
      font-size: 12px;
      margin: 0;
      cursor: pointer;
    }
  }
`

export const OptionTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 4px;
`

export const LoyaltyLevelBadge = styled.div`
  padding: 2px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme?.colors?.gray4};
`

export const Text = styled.p`
  &&& {
    font-size: 12px;
    margin: 0;
  }
`

export const TextQuery = styled(Text)`
  &&& {
    color: ${({ theme }) => theme?.colors?.gray5};
  }
`

export const ButtonStyle = styled.div<ContainerGridProps>`
  &&& {
    align-items: flex-end;
    display: flex;
    width: 85px;

    /* Tooltip container */
    .tooltip {
      position: relative;
      display: inline-block;
      border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
      .tooltiptext {
        width: 245px;
        white-space: pre-wrap;
        top: 28px;
        background-color: #273240;
        color: #fff;
        border-radius: 4px;
        line-height: 20px;
        text-align: left;
        right: 0px;
        padding: 10px;
        font-size: 14px !important;
        font-weight: lighter;
        z-index: 10;
        position: absolute;
        z-index: 1;
        &::after {
          bottom: 100%;
          right: 26px;
          border: solid transparent;
          content: '';
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-bottom-color: #273240;
          border-width: 8px;
          margin-left: -65px;
        }
      }
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100%;
    }
  }
`
export const RenderOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;

  &.align-right {
    align-items: flex-end;
  }
`

export const RenderNoOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  padding: 10px;
`

export const RenderOptionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`

export const Link = styled.p`
  color: ${({ theme }) => theme?.colors?.info};
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    text-decoration: none;
  }
`

type ImageGroupProps = {
  src: string
}
export const ImageGroup = styled.img<ImageGroupProps>`
  src: ${({ src }) => `local(${src})`};
  width: 20px;
  height: 20px;
`

export const ButtonSearchCartStyleDiv = styled.div`
  &&& {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 15px;
    width: unset;

    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100%;
      margin-top: 18px;
    }
  }
`

export const ShoppingCartDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  @media (max-width: calc(${BREAKPOINT_SM})) {
    display: none;
  }
`

// Faz o spacing por aqui em vez das props do MuiGrid
export const GridChildren = styled(MuiGrid)`
  &&& {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 20px);
    margin: -10px;
  }

  & > .MuiGrid-item {
    padding: 0px 10px;
  }
`

export const RoomHearder = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: space-between;
    margin-bottom: 15px;
  }
`

export const ContainerAddOccupation = styled.div`
  &&& {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 15px;
  }
`

export const RoomContainer = styled.div`
  &&& {
    width: 100%;

    .room-content {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      align-items: center;
    }

    .select-rooms-content {
      width: 131px;
    }
  }
`

export const GroupTitle = styled(TitleRoom)`
  &&& {
    margin-top: 10px !important;
  }
`
